import React from "react";
import { useI18n } from "../context/I18nContext";

export function Stats({ settings = {} }) {
  const { t } = useI18n();

  // Admin'den geliyorsa kullan, yoksa translations fallback
  const heading = settings.stats_heading || t.stats.heading;
  const sub     = settings.stats_sub     || t.stats.sub;
  const items   = (settings.stats_items && settings.stats_items.length > 0)
    ? settings.stats_items
    : t.stats.items;

  return (
    <section
      data-testid="stats-section"
      className="bg-[#0d1b2a] text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid opacity-30 pointer-events-none" />
      <div className="relative max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-12">
          <div className="lg:col-span-7">
            <div data-reveal className="text-[11px] uppercase tracking-[0.22em] font-bold text-[#ffb703]">
              YGS
            </div>
            <h2
              data-reveal
              className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight"
              style={{ fontFamily: "Chivo, Inter, sans-serif" }}
              data-testid="stats-heading"
            >
              {heading}
            </h2>
          </div>
          <p data-reveal className="lg:col-span-5 text-base text-white/70 leading-relaxed">
            {sub}
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-xl overflow-hidden border border-white/10">
          {items.map((s, i) => (
            <div
              key={i}
              data-reveal
              data-testid={`stat-${i}`}
              className="bg-[#0d1b2a] p-7 lg:p-9 group hover:bg-white/[0.02] transition-colors"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <div
                className="text-4xl sm:text-5xl lg:text-6xl font-black text-[#ffb703] tracking-tight"
                style={{ fontFamily: "Chivo, Inter, sans-serif" }}
              >
                {s.value}
              </div>
              <div className="mt-2 text-xs uppercase tracking-[0.18em] font-bold text-white/70">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
